import { REQUEST_METHOD } from 'utils/apiClient'
import { APIRoute } from 'routes/api'
import { createApiThunk } from 'utils/thunkWrapper'
import { updateCourseProviderMapping } from 'store/course/thunks'
import { sendSuccessNotification } from 'utils/notifications'

export const getClub = createApiThunk<Club, number>({
  action: 'club/get',
  method: REQUEST_METHOD.GET,
  formatUrl: (id) => APIRoute.GET_CLUB(id),
})

export const createClub = createApiThunk<Club, ClubSavePayload>({
  action: 'club/create',
  method: REQUEST_METHOD.POST,
  formatUrl: () => APIRoute.POST_CLUB,
  getData: (payload) => payload.data,
})

export const editClub = createApiThunk<Club, ClubEditPayload>({
  action: 'club/edit',
  method: REQUEST_METHOD.PUT,
  formatUrl: (payload) => APIRoute.PUT_CLUB(payload.id),
  getData: (payload) => payload.data,
})

export const deactivateClub = createApiThunk<Club, number>({
  action: 'club/deactivate',
  method: REQUEST_METHOD.PUT,
  formatUrl: (id) => APIRoute.PUT_CLUB_DEACTIVATE(id),
})

export const reactivateClub = createApiThunk<Club, number>({
  action: 'club/reactivate',
  method: REQUEST_METHOD.PUT,
  formatUrl: (id) => APIRoute.PUT_CLUB_REACTIVATE(id),
})

export const getClubCourses = createApiThunk<Course[], number>({
  action: 'club/getCourses',
  method: REQUEST_METHOD.GET,
  formatUrl: (id) => APIRoute.GET_CLUB_COURSES(id),
})

export const transferClubProviderMapping = createApiThunk<Club, ClubProviderMappingTransferPayload>({
  action: 'club/transferProviderMapping',
  method: REQUEST_METHOD.POST,
  formatUrl: () => APIRoute.POST_TRANSFER_CLUB_PROVIDER_MAPPING,
  getData: (payload) => payload,
  onSuccess: (payload, response, thunkApi) => {
    const club = response
    thunkApi.dispatch(getClubCourses(club.id))
  },
})

export const generateInitialMapping = createApiThunk<Club, number>({
  action: 'club/generateInitialMapping',
  method: REQUEST_METHOD.POST,
  formatUrl: (id) => APIRoute.POST_CLUB_GENERATE_INITIAL_MAPPING(id),
})

export const updateClubProviderMapping = createApiThunk<
  updateClubProviderMappingResponse,
  updateClubProviderMappingPayload
>({
  action: 'club/addProviderMapping',
  method: REQUEST_METHOD.PUT,
  formatUrl: (payload) => APIRoute.PUT_ADD_CLUB_PROVIDER_MAPPING(payload.clubId, payload.clubProviderMapId),
  getData: (payload) => payload,
  onSuccess: (payload, response, thunkApi) => {
    sendSuccessNotification('Club Mapped succesfully')
    thunkApi.dispatch(
      updateCourseProviderMapping({
        courseId: payload.courseId,
        newProviderId: payload.newProviderCourseId,
        newProvider: payload.newProvider,
        courseProviderMapId: payload.courseProviderMapId,
      }),
    )
  },
})

export const unmapClubProviderMapping = createApiThunk<
  updateClubProviderMappingResponse,
  UnmapClubProviderMappingPayload
>({
  action: 'club/unmapProviderMapping',
  method: REQUEST_METHOD.PUT,
  formatUrl: (payload) => APIRoute.PUT_ADD_CLUB_PROVIDER_MAPPING(payload.clubId, payload.clubProviderMapId),
  getData: (payload) => payload,
  getSuccessMessage: (payload) => payload.successMessage,
  onSuccess: (payload, _response, thunkApi) => {
    thunkApi.dispatch(getClub(payload.clubId))
    thunkApi.dispatch(getClubCourses(payload.clubId))
  },
})
